import React from "react";
import { useEnumStrings } from "../enumStrings";

interface FeaturedMemberBannerGuidanceProps {
  className?: string;
  style?: React.CSSProperties;
}

const FeaturedMemberBannerGuidance = ({
  className,
  style,
}: FeaturedMemberBannerGuidanceProps): React.ReactElement => {
  const enumStrings = useEnumStrings();

  return (
    <p className={className} style={style}>
      {enumStrings.common.featuredMemberBannerGuidance}
    </p>
  );
};

export default FeaturedMemberBannerGuidance;
